export enum EClientsAction {
    BLOCK = 'Заблокировать',
    ACTIVE = 'Активировать',
    SEND_NOTIFICATION = 'Отправить уведомление',
    ADD_BONUSES = 'Пополнить бонусы',
    DEDUCT_BONUSES = 'Списать бонусы',
    DELETE = 'Удалить',
}

export enum ECardAction {
    BLOCK = 'Заблокировать',
    ACTIVE = 'Активировать',
    CHANGE_TEMPLATE = 'Сменить шаблон',
}
export enum ERegFormAction {
    BLOCK = 'Заблокировать форму',
    ACTIVE = 'Активировать форму',
    UPDATE_REG_FORM = 'Изменить форму',
    DELETE_REG_FORM = 'Удалить форму',
}

export enum ENotifyType {
    CLIENT_ID = 'client_id',
    TEMPLATE_ID = 'template_id',
    CARD_ID = 'card_id',
    ALL = 'all',
}

export enum ENotifyStatus {
    READY = 'В ОЖИДАНИИ',
    RUNNED = 'ОТПРАВЛЕНО',
    CANCELLED = 'ОТМЕНЕНО',
    FINISHED = 'ДОСТАВЛЕНО',
}

export enum ENotifyAction {
    DUBBLE = 'Повторить',
    CANCEL = 'Отменить',
    DELETE = 'Удалить',
    EDIT = 'Изменить',
}

export enum ENotificationStatus {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warning',
    DEFAULT = 'default',
}

export enum EClientsFilterValues {
    STATUS = 'По статусу',
    AGE = 'По возрасту',
    CREATED = 'По дате создания',
    TEMPLATES = 'По макетам',
    GENDER = 'По полу',
    VISITS = 'По дате визита',
}

export enum ETransactionFilterValues {
    DATE = 'По дате',
    TEMPLATES = 'По макетам',
    GENDER = 'По полу',
    PAYED = 'По способу оплаты',
    HOURS = 'По времени',
}

export enum EAgePeriod {
    START = 18,
    END = 65,
}

export enum ERROR_MESSAGE {
    REQUIRED = 'Поле обязательное для заполнения',
    MORE_ZERO = 'Значение должно быть больше 0',
    MAX_NUMBER = 'Значение должно быть меньше 1 000 000',
    TOO_LONG = 'Слишком длинное поле',
}

export enum ECallStatus {
    SUCCESS = 'success',
    MISSED = 'missed',
}
